import React from 'react'

function withLabel(WrappedComponent, preventClick = false) {
  return ({ label = '', name, required, hasError, hint = '', disabled, ...rest }) => {
    const wrapped = (
      <WrappedComponent
        id={name}
        name={name}
        disabled={disabled}
        hasError={hasError}
        {...rest}
      />
    )

    return !!label ? (
      <label
        htmlFor={name}
        onClick={e => preventClick && e.preventDefault()}
      >
        <strong>
          {label}
          {required && ' *'}
          {!!hint && <span>&nbsp;&nbsp;({hint})</span>}
        </strong>
        {wrapped}
      </label>
    ) : wrapped
  }
}

export default withLabel



// WEBPACK FOOTER //
// ./src/components/UI/Label/index.js